<template>
  <div>
    <b-navbar id="header" type="light" variant="light" class="header-top" sticky>
      <b-navbar-nav class="mr-2">
        <b-button size="sm" variant="primary" @click="onBack()">
          <font-awesome-icon icon="chevron-left" class="mr-1"/>
          Назад
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="mx-2">
        <template v-if="isBusy">
          <h4 class="mb-0" id="location-ellipsis-loading">Загрузка объекта</h4>
        </template>
        <template v-else>
          <h4 class="mb-0">{{title}}</h4>
        </template>
      </b-navbar-nav>
      <b-navbar-nav class="mr-auto ml-2">
        <b-button
          size="sm"
          :variant="getReadOnlyVariant()"
          v-if="readOnlyButtonVisible"
          @click.stop="readOnlyTapped()"
        >
          <font-awesome-icon :icon="getReadOnlyIcon()" class="mr-1" />
          {{getReadOnlyTitle()}}
        </b-button>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto">
        <b-row align-v="center">
          <b-col cols="auto">
            <b-button size="sm" variant="success" :disabled="isDisabled || loading" @click="handleSubmit()">
              <b-spinner v-if="loading" small></b-spinner>
              <font-awesome-icon icon="save" class="mr-1" />
              Сохранить
            </b-button>
          </b-col>
        </b-row>
      </b-navbar-nav>
    </b-navbar>

    <b-skeleton-wrapper :loading="isBusy">
      <template #loading>
        <b-card no-body>
          <!-- Tabs -->
          <b-tabs card>
            <b-tab title="Основная" disabled/>
            <b-tab title="Детали" disabled/>
            <b-tab title="Шаблоны вакансий" disabled/>
            <b-tab title="Подбор" disabled/>
            <b-tab title="Услуги исполнителей" disabled/>
            <b-tab title="Работы" disabled/>
            <b-tab title="Расходы" disabled/>
            <b-tab title="Сотрудники" disabled/>
            <b-tab title="Контакты" disabled/>
            <b-tab title="Документы" disabled/>
            <b-tab title="Медиафайлы" disabled/>
          </b-tabs>
          <b-card border-variant="white">
            <b-card bg-variant="light">
              <!-- Название -->
              <b-row class="mb-2 mt-2">
                <b-col>
                  <b-skeleton width="5%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="45%"/>
                </b-col>
              </b-row>
              <!-- Заказчик, Город -->
              <b-row class="mb-2">
                <b-col cols="6">
                  <b-skeleton width="12%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="45%"/>
                </b-col>
                <b-col cols="3" class="d-flex align-items-center mt-2">
                  <b-skeleton type="input" width="60%" height="50%"/>
                </b-col>
                <b-col cols="3">
                  <b-skeleton width="26%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="45%"/>
                </b-col>
              </b-row>
              <!-- Организация, Источник -->
              <b-row>
                <b-col cols="6">
                  <b-skeleton width="7%" height="17%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
                  <b-skeleton width="20%" height="14%"/>
                </b-col>
                <b-col>
                  <b-skeleton width="25%" height="17%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
                </b-col>
                <b-col>
                  <b-skeleton width="63%" height="17%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="30%" class="mb-2"/>
                </b-col>
              </b-row>
              <!-- Тип оплаты, статус, кагетория -->
              <b-row class="mb-1">
                <b-col cols="6">
                  <b-skeleton width="14%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="29%" height="32%"/>
                </b-col>
                <b-col cols="3">
                  <b-skeleton width="17%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
                <b-col cols="3">
                  <b-skeleton width="27%" height="21%" class="mb-2"/>
                  <b-skeleton type="input" width="100%" height="44%"/>
                </b-col>
              </b-row>
              <!-- Расходы, Комиссия, Налог, Комиссия, НДС -->
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="13%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="32%" height="45%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="12%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="32%" height="45%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="9%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="32%" height="45%"/>
                </b-col>
              </b-row>
              <b-row class="mb-2">
                <b-col>
                  <b-skeleton width="11%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="32%" height="45%"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-skeleton width="7%" height="24%" class="mb-2"/>
                  <b-skeleton type="input" width="32%" height="45%"/>
                </b-col>
              </b-row>
            </b-card>
          </b-card>
        </b-card>
      </template>

      <template #default>
        <b-card no-body>
          <b-tabs card>
            <b-tab title="Основная" active>
              <b-card bg-variant="light">
                <b-form-group id="group-name" :label="$t('message.locations.modal.nameInput')">
                  <b-form-input
                    size="sm"
                    type="text"
                    :disabled="isDisabled"
                    placeholder="Введите название"
                    :state="getFieldState('name')"
                    v-model="newItem.name"
                  />
                </b-form-group>

                <b-row>
                  <b-col cols="6">
                    <b-form-group id="group_customer" :label="$t('message.locations.modal.customerInput')">
                      <customer-select
                        ref="customer_select"
                        :is-disabled="isDisabled"
                        :state="getFieldState('customer_id')"
                        :initial-id="newItem.customer_id"
                        @onSelect="onSelectCustomer"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col cols="3" class="d-flex align-items-end">
                    <b-button
                      v-b-toggle.collapse-customer-details
                      variant="outline-primary"
                      size="sm"
                      class="mb-3"
                    >
                      <font-awesome-icon :icon="isCustomerOpen ? 'chevron-up' : 'chevron-down'" class="mr-1"/>
                      {{ isCustomerOpen ? 'Скрыть реквизиты' : 'Показать реквизиты' }}
                    </b-button>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group id="group-town" label="Город">
                      <b-form-select
                        size="sm"
                        :disabled="isDisabled"
                        :state="getFieldState('town_id')"
                        v-model="newItem.town_id"
                      >
                        <option :value="null">Выберите город</option>
                        <option v-for="option in towns" :value="option.id">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-collapse id="collapse-customer-details" v-model="isCustomerOpen">
                  <b-card class="mb-2">
                    <h6>Банковские реквизиты</h6>
                    <b-row cols="2" class="align-items-end">
                      <b-col>
                        <b-form-group id="group-bik" :label="$t('message.customers.modal.bik')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.bik"
                          />
                        </b-form-group>

                        <b-form-group id="group-cor-account" :label="$t('message.customers.modal.cor_account')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.cor_account"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group id="group-bank" :label="$t('message.customers.modal.bank')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.bank"
                          />
                        </b-form-group>

                        <b-form-group id="group-checking-account" :label="$t('message.customers.modal.checking_account')">
                          <b-form-input
                            size="sm"
                            autocomplete="off"
                            disabled
                            v-model="customer.checking_account"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-collapse>

                <b-row>
                  <b-col cols="6">
                    <b-form-group id="group_org" label="Организация" description="Будет отображаться при выставлении счёта">
                      <organization-select
                        ref="organization_select"
                        :is-disabled="isDisabled"
                        :initial-id="newItem.organization_id"
                        :state="getFieldState('organization_id')"
                        @onSelect="onSelectOrg"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="group-marketing-source" label='Источник'>
                      <b-form-select
                        size="sm"
                        :disabled="isDisabled"
                        :state="getFieldState('marketing_source_id')"
                        v-model="newItem.marketing_source_id"
                      >
                        <option :value="0">Выберите источник</option>
                        <option v-for="option in marketingSources" :value="option.id">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="group-marketing-source-comment" label="Источник комментарий">
                      <b-form-input
                        type="text"
                        size="sm"
                        :disabled="isDisabled"
                        v-model="newItem.marketing_source_comment"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-form-group id="group-price" label="Тип оплаты">
                      <b-form-radio-group
                        size="sm"
                        v-model="newItem.payment_type"
                        :disabled="isDisabled"
                        :options="paymentOptions">
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group id="group-status" label="Статус">
                      <b-form-select
                        size="sm"
                        :disabled="isDisabled"
                        v-model="newItem.status_id"
                      >
                        <option :value="0">Выберите статус</option>
                        <option v-for="option in statuses" :key="option.id" :value="option.id">
                          {{ option.name }}
                        </option>
                      </b-form-select>
                    </b-form-group>
                  </b-col>
                  <b-col cols="3">
                    <b-form-group id="group-category" label="Категория">
                      <b-form-input
                        size="sm"
                        placeholder="Введите категорию для БалансПРО"
                        :disabled="isDisabled"
                        v-model="newItem.category_name"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canLocationReadFinance()">
                  <b-col lg="4">
                    <b-form-group id="group-management-cost" label="Управленческие расходы">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.management_cost"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canLocationReadFinance()">
                  <b-col lg="4">
                    <b-form-group id="group-smz-cost" label="Комиссия сервиса СМЗ">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.smz_cost"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canLocationReadFinance()">
                  <b-col lg="4">
                    <b-form-group id="group-profit-tax" label="Налог на прибыль">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.profit_tax"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canLocationReadFinance()">
                  <b-col lg="4">
                    <b-form-group id="group-transfer-commission" label="Комиссия на трасфер">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.transfer_commission"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canLocationReadFinance() && (newItem.payment_type === 1 || newItem.payment_type === 2)">
                  <b-col lg="4">
                    <b-form-group id="group-nds" label="НДС">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.nds"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-row v-if="canLocationReadFinance() && newItem.payment_type === 2">
                  <b-col lg="4">
                    <b-form-group id="group-bank-commission" label="Банковская коммисия для ИП">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.bank_commission"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="canLocationReadFinance() && newItem.payment_type === 2">
                  <b-col lg="4">
                    <b-form-group id="group-ip-commission" label="Комиссия на вывод ИП">
                      <b-input-group size="sm">
                        <b-form-input
                          size="sm"
                          type="number"
                          min="0"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          placeholder="0"
                          v-model.number="newItem.ip_commission"
                        />
                        <template #append>
                          <b-input-group-text size="sm">%</b-input-group-text>
                        </template>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>
            </b-tab>
            <b-tab title="Детали">
              <b-card bg-variant="light">
                <b-form-group id="group-address" :label="$t('message.locations.modal.addressInput')">
                  <b-form-input
                    size="sm"
                    type="text"
                    :disabled="isDisabled"
                    v-model="newItem.address"
                  />
                </b-form-group>

                <b-row>
                  <b-col cols="4">
                    <b-form-group id="group-contract" :label="$t('message.locations.modal.contractInput')">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.contract"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group id="group-contact" :label="$t('message.locations.modal.contactInput')">
                      <b-form-input
                        size="sm"
                        type="text"
                        :disabled="isDisabled"
                        v-model="newItem.contact"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-form-group id="group-description" label="Описание">
                  <b-form-textarea
                    size="sm"
                    :disabled="isDisabled"
                    placeholder="Заполните необходимую информацию об объекте"
                    v-model="newItem.description"
                    :rows="7"
                    :max-rows="20"
                    no-resize
                  />
                </b-form-group>
                <b-form-group id="group-posting-order" label="Порядок выхода">
                  <b-form-textarea
                    size="sm"
                    :disabled="isDisabled"
                    placeholder="Заполните необходимую информацию о порядке выхода на объект"
                    v-model="newItem.posting_order"
                    :rows="7"
                    :max-rows="20"
                    no-resize
                  />
                </b-form-group>
                <b-form-group id="group-interview-script" label="Скрипт интервью">
                  <b-form-textarea
                    size="sm"
                    :disabled="isDisabled"
                    placeholder="Критически важные вопросы для кандидатов перед их одобрением"
                    v-model="newItem.interview_script"
                    :rows="7"
                    :max-rows="20"
                    no-resize
                  />
                </b-form-group>
                <b-form-group id="group-employment-documents" label="Документы для трудоустройства">
                  <b-form-textarea
                    size="sm"
                    :disabled="isDisabled"
                    placeholder="Введите требуемые документы для трудоустройства граждан СНГ и ЕАЭС"
                    v-model="newItem.employment_documents"
                    :rows="7"
                    :max-rows="20"
                    no-resize
                  />
                </b-form-group>
              </b-card>
            </b-tab>
            <b-tab title="Шаблоны вакансий">
              <location-vacancies ref="location_vacancies" :is-disabled="isDisabled"/>
            </b-tab>
            <b-tab title="Подбор">
              <b-card no-body>
                <recruit-tasks
                  v-if="newItem.id"
                  :location-id="newItem.id"
                  :location-name="newItem.name"
                  :disabled-routing="true"
                  :is-integrated="true"
                  @refresh="onRecruitTasksRefresh"
                />
                <b-alert v-else show variant="danger" class="pb-3 mb-0">
                  Сохраните карточку объекта, чтобы просматривать заявки на подбор.
                </b-alert>
              </b-card>
            </b-tab>
            <b-tab title="Услуги исполнителей" :active.sync="servicesTabActive">
              <location-work-services ref="location_work_services" :is-disabled="isDisabled"/>
            </b-tab>
            <b-tab title="Работы">
              <location-works ref="location_works" :is-disabled="isDisabled"></location-works>
            </b-tab>
            <b-tab title="Расходы" v-if="canLocationReadFinance()">
              <location-costs ref="location_costs" :is-disabled="isDisabled"></location-costs>
            </b-tab>
            <b-tab title="Сотрудники" v-if="canLocationReadFinance()">
              <b-card bg-variant="light">
                <b-row v-if="canLocationReadFinance()">
                  <b-col cols="4">
                    <b-form-group id="group_rate" label="Тип ставки для сотрудников">
                      <b-form-radio-group
                        size="sm"
                        v-model="newItem.rate_type"
                        :disabled="isDisabled || !canLocationEditFinance()"
                        :options="rateOptions">
                      </b-form-radio-group>
                    </b-form-group>
                  </b-col>
                </b-row>

                <b-card class="mt-lg-0 mt-2" no-body>
                  <b-card-header>
                    <b-form inline>
                      Руководитель
                      <user-select
                        id="input_project_select"
                        class="ml-2 mr-2 flex-fill"
                        ref="project_select"
                        :is-disabled="isDisabled || !canLocationEditFinance()"
                        v-on:onSelect="onSelectProject"
                      />
                      <b-button
                        variant="success"
                        size="sm"
                        :disabled="isDisabled || !selectedProjectId || !canLocationEditFinance()"
                        @click="onAddProject(selectedProjectId)"
                      >
                        <font-awesome-icon icon="plus" class="mr-1"/>
                        Добавить
                      </b-button>
                    </b-form>
                  </b-card-header>

                  <b-table
                    id="location-projects"
                    ref="projects"
                    class="mb-0 text-small"
                    striped
                    small
                    thead-class="hidden_header"
                    responsive
                    show-empty
                    :busy.sync="isBusy"
                    :items="projects"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :empty-text="$t('message.common.emptyTable')"
                  >
                    <template #table-busy>
                      <div class="text-center text-success my-2">
                        <b-spinner class="align-middle"/>
                        <strong>Загрузка</strong>
                      </div>
                    </template>
                    <template #cell(name)="row">
                      {{row.item.name}}
                      <p class="text-secondary m-0">
                        {{row.item.role_name}}
                      </p>
                    </template>
                    <template #cell(rate)="row">
                      <b-input-group size="sm" prepend="Ставка">
                        <b-form-input
                          id="input-rate"
                          type="number"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          size="sm"
                          autocomplete="off"
                          v-model.number="row.item.rate">
                        </b-form-input>

                        <template #append>
                          <b-input-group-text size="sm">{{ getRateSymbol() }}</b-input-group-text>
                        </template>
                      </b-input-group>
                    </template>
                    <template #cell(action)="row">
                      <b-button
                        variant="danger"
                        size="sm"
                        :disabled="isDisabled || !canLocationEditFinance()"
                        @click="onRemoveProject(row.item)"
                      >
                        <font-awesome-icon icon="trash"/>
                      </b-button>
                    </template>
                  </b-table>
                </b-card>

                <hr />
                <b-card class="mt-3" no-body>
                  <b-card-header>
                    <b-form inline>
                      Сотрудники
                      <user-select
                        id="input_user_select"
                        class="ml-2 mr-2 flex-fill"
                        ref="user_select"
                        :is-disabled="isDisabled || !canLocationEditFinance()"
                        v-on:onSelect="onSelectUser"
                      />
                      <b-button
                        variant="success"
                        size="sm"
                        :disabled="isDisabled || !selectedUserId || !canLocationEditFinance()"
                        @click="onAddUser(selectedUserId)"
                      >
                        <font-awesome-icon icon="plus" class="mr-1"/>
                        Добавить
                      </b-button>
                    </b-form>
                  </b-card-header>

                  <b-table
                    id="location-users"
                    ref="users"
                    class="mb-0 text-small"
                    striped
                    small
                    thead-class="hidden_header"
                    responsive
                    show-empty
                    :busy.sync="isBusy"
                    :items="users"
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :empty-text="$t('message.common.emptyTable')"
                  >
                    <template #table-busy>
                      <div class="text-center text-success my-2">
                        <b-spinner class="align-middle"/>
                        <strong>Загрузка</strong>
                      </div>
                    </template>
                    <template #cell(name)="row">
                      {{row.item.name}}
                      <p class="text-secondary m-0">
                        {{row.item.role_name}}
                      </p>
                    </template>
                    <template #cell(rate)="row">
                      <b-input-group size="sm" prepend="Ставка">
                        <b-form-input
                          id="input-rate"
                          type="number"
                          :disabled="isDisabled || !canLocationEditFinance()"
                          size="sm"
                          autocomplete="off"
                          v-model.number="row.item.rate">
                        </b-form-input>

                        <template #append>
                          <b-input-group-text size="sm">{{ getRateSymbol() }}</b-input-group-text>
                        </template>
                      </b-input-group>
                    </template>
                    <template #cell(action)="row">
                      <b-button
                        variant="danger"
                        size="sm"
                        :disabled="isDisabled || !canLocationEditFinance()"
                        @click="onRemoveUser(row.item)"
                      >
                        <font-awesome-icon icon="trash"/>
                      </b-button>
                    </template>
                  </b-table>
                </b-card>
              </b-card>
            </b-tab>
            <b-tab title="Контакты">
              <location-contacts ref="location_contacts" :is-disabled="isDisabled"></location-contacts>
            </b-tab>
            <b-tab title="Документы">
              <location-files ref="location_files" :is-disabled="isDisabled"></location-files>
            </b-tab>
            <b-tab title="Медиафайлы">
              <location-passport ref="location_passport_files" :is-disabled="isDisabled"/>
            </b-tab>
          </b-tabs>
        </b-card>
      </template>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
import locations from "../../network/locations";
import users from "../../network/users";
import catalogs from "../../network/catalogs";
import customers from "../../network/customers";
  import helpers from "../../utilites/helpers";
  import permissions, {PERM} from "../../utilites/permissions";
    import CustomerSelect from "../Customers/CustomerSelect";
    import UserSelect from "../Users/UserSelect";
    import LocationCosts from "./LocationCosts";
    import LocationFiles from "./LocationFiles";
    import LocationContacts from "./LocationContacts";
    import LocationWorks from "./LocationWorks";
    import LocationWorkServices from "./LocationWorkServices";
    import OrganizationSelect from "../Organizations/OrganizationSelect";
    import LocationVacancies from "./LocationVacancies.vue";
    import LocationPassport from "./LocationPassport.vue";
    import RecruitTasks from "../Recruiting/RecruitTasks.vue";

export default {
  name: "Location",
  components: {
    LocationPassport, LocationVacancies, LocationContacts, CustomerSelect, UserSelect, LocationCosts, LocationFiles, OrganizationSelect, LocationWorks, LocationWorkServices, RecruitTasks
  },
  mixins: [
    locations, catalogs, users, customers,
    helpers, permissions
  ],
  props: ['isRead'],
  data() {
    return {
      title:'Объект',
      newItem: {
        id: null,
        name: '',
        description: '',
        posting_order: '',
        interview_script: '',
        employment_documents: '',
        address: '',
        contact: '',
        organization_id: 0,
        organization_name: '',
        customer_id: 0,
        contract: '',
        town_id: null,
        town_name: '',
        marketing_source_id: 0,
        marketing_source_comment: '',
        location_users: [],
        payment_type: 1,
        price: 0,
        rate: 0,
        read_only: false,
        rate_type: 1,
        management_cost: 5,
        smz_cost: 2,
        profit_tax: 2,
        nds: 22,
        transfer_commission: 30,
        bank_commission: 1,
        ip_commission: 7,
        category_name: '',
        status_id: 0
      },
      customer: {},
      isDisabled: false,
      towns: [],
      marketingSources: [],
      statuses: [],
      paymentOptions: [
        {text: 'Нал', value: 0},
        {text: 'ООО', value: 1},
        {text: 'ИП', value: 2},
      ],
      rateOptions: [
        {text: 'Проценты (%)', value: 1},
        {text: 'Рубли (₽)', value: 2},
      ],
      users: [],
      projects: [],
      selectedUserId: null,
      selectedProjectId: null,
      fields: [
        {
          key: 'name',
          label: 'Имя',
        },
        {
          key: 'rate',
          label: 'Ставка',
          class: 'widthRate',
        },
        {
          key: 'action',
          label: 'Действия',
          class: 'widthLocationAction',
        },
      ],
      currentPage: 1,
      perPage: 40,
      isBusy: false,
      loading: false,
      readOnlyButtonVisible: false,
      servicesTabActive: false,
      isCustomerOpen: false,
    }
  },
  async created() {
    this.isBusy = true;
    this.loading = true;
    this.towns = (await this.getTowns({})).data.items;
    this.marketingSources = (await this.getMarketingSources({})).data.items;
    this.statuses = (await this.getLocationStatuses({})).data.items;
    await this.updateView();
  },
  watch: {
    servicesTabActive(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          if (this.$refs.location_work_services) {
            this.$refs.location_work_services.showHint();
          }
        });
      }
    }
  },
  methods: {
    async updateView() {
      const locationId = this.$route.params.location_id;
      if (locationId != null) {
        await this.getLocation(locationId);
      } else {
        this.isBusy = false;
        this.loading = false;
      }
    },
    async getLocation(locationId) {
      const locationResult = await this.getLocationById(locationId);
      this.isBusy = false;

      if (!locationResult || !locationResult.data) {
        this.showError("Что-то пошло не так. Попробуйте обновить страницу и повторить действие.");
        this.isBusy = false;
        this.loading = false;
        return;
      }

      this.newItem = locationResult.data;
      this.title = this.newItem.name;

      this.prepareReadOnly();

      await this.getCustomer(this.newItem.customer_id);
      await this.$refs.customer_select.configure(this.newItem.customer_id);

      if (this.$refs.organization_select != null) {
        await this.$refs.organization_select.configure(this.newItem.organization_id);
      }

      const location_users = this.newItem.location_users;

      let locationUsers = [];
      let locationProjects = [];
      for (const index in location_users) {
        const location_user = location_users[index];
        const user = await this.loadUser(location_user.user_id);
        const locationUser = this.mapUserToLocationUser(user, location_user.rate);
        if (location_user.location_position_id === 2) {
          locationUsers.push(locationUser);
        }

        if (location_user.location_position_id === 1) {
          locationProjects.push(locationUser);
        }
      }

      this.users = locationUsers;
      this.projects = locationProjects;

      if (this.$refs.project_select != null) {
        await this.$refs.project_select.configure(0);
      }

      if (this.$refs.user_select != null) {
        await this.$refs.user_select.configure(0);
      }

      if (this.$refs.location_costs != null) {
        await this.$refs.location_costs.configure(this.newItem.id);
      }

      if (this.$refs.location_contacts != null) {
        await this.$refs.location_contacts.configure(this.newItem.id);
      }

      if (this.$refs.location_works != null) {
        await this.$refs.location_works.configure(this.newItem.id, this.newItem.locations_work_types);
      }

      if (this.$refs.location_work_services != null) {
        await this.$refs.location_work_services.configure(this.newItem.id, this.newItem.location_work_services);
      }

      // Конфигурируем файлы
      if (this.$refs.location_files != null) {
        await this.$refs.location_files.configure(this.newItem.id);
      }

      if (this.$refs.location_passport_files != null) {
        await this.$refs.location_passport_files.configure(this.newItem.id);
      }

      if (this.$refs.location_vacancies != null) {
        await this.$refs.location_vacancies.configure(this.newItem.id, this.newItem.name);
      }

      this.loading = false;
    },
    onBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/locations').catch(()=>{});
      }
    },
    async handleSubmit() {
      if (this.newItem.name.length < 3) {
        this.showSubmitError("Введите название объекта (минимум 3 символа).");
        return;
      }

      if (this.newItem.customer_id === 0) {
        this.showSubmitError("Выберите заказчика объекта.");
        return;
      }

      if (!this.newItem.town_id) {
        this.showSubmitError("Выберите город.");
        return;
      }

      if (this.newItem.organization_id === 0) {
        this.showSubmitError("Выберите организацию объекта.");
        return;
      }

      if (this.newItem.marketing_source_id === 0) {
        this.showSubmitError("Выберите источник объекта.");
        return;
      }

      if (this.users.length === 0) {
        this.showSubmitError("Добавьте сотрудников имеющих доступ к объекту.");
        return;
      }

      if (this.$refs.location_works) {
        if (!this.$refs.location_works.items.every(v => v.work_type_id > 0)) {
          this.showSubmitError('Выберите вид работ объекта.');
          return;
        }
      }

      if (this.$refs.location_work_services) {
        if (!this.$refs.location_work_services.items.every(v => v.work_service_id > 0)) {
          this.showSubmitError('Выберите вид услуги исполнителя.');
          return;
        }
      }

      if (this.$refs.location_vacancies) {
        if (!this.$refs.location_vacancies.items.every(v => v.vacancy_id > 0)) {
          this.showSubmitError('Выберите вакансию объекта.');
          return;
        }

        if (!this.$refs.location_vacancies.items.every(v => v.workers_count > 0)) {
          this.showSubmitError('Укажите требуемое количество исполнителей.');
          return;
        }
      }

      if (this.$refs.location_costs) {
        if (!this.$refs.location_costs.items.every(v => v.cost_type > 0)) {
          this.showSubmitError('Введите тип расходов объекта.');
          return;
        }

        if (!this.$refs.location_costs.items.every(v => this.dateValidation(v.start_date))) {
          this.showSubmitError('Введите дату расходов объекта.');
          return;
        }

        if (!this.$refs.location_costs.items.every(v => this.dateValidation(v.end_date))) {
          this.showSubmitError('Введите дату расходов объекта.');
          return;
        }

        if (!this.$refs.location_costs.items.every(v => this.isNumberOrNull(v.sum))) {
          this.showSubmitError("Укажите сумму расходов в виде числа.");
          return;
        }
      }

      this.loading = true;

      // Менеджеры
      this.newItem.location_users = this.users.map(function (obj) {
        return {
          location_id: this.newItem.id,
          user_id: obj.id,
          rate: obj.rate,
          location_position_id: 2,
          location_position_name: 'Менеджер',
        }
      }.bind(this));

      // Руководители
      const location_projects = this.projects.map(function (obj) {
        return {
          location_id: this.newItem.id,
          user_id: obj.id,
          rate: obj.rate,
          location_position_id: 1,
          location_position_name: 'Руководитель',
        }
      }.bind(this));

      // Объединяем пользователей
      this.newItem.location_users = this.newItem.location_users.concat(location_projects);

      if (this.$refs.location_works != null) {
        this.newItem.locations_work_types = this.$refs.location_works.items;
      }

      if (this.$refs.location_work_services != null) {
        this.newItem.location_work_services = this.$refs.location_work_services.items;
      }

      let locationResult;
      if (this.newItem.id > 0) {
        locationResult = await this.putLocation(this.newItem);
      } else {
        locationResult = await this.postLocation(this.newItem);
      }

      if (!locationResult || !locationResult.data) {
        this.showError('Что-то пошло не так. Попробуйте обновить страницу и повторить действие.');
        this.loading = false;
        return;
      }

      this.newItem.id = locationResult.data.id;

      // После сохранения location_id сохраняем остальные сущности
      if (this.$refs.location_vacancies != null) {
        const vacancyResult = await this.$refs.location_vacancies.saveVacancies(this.newItem);

        if (vacancyResult && vacancyResult.error) {
          this.showSubmitError("Ошибка сохранения вакансий объекта.");
          this.loading = false;
          return;
        }
      }

      if (this.$refs.location_costs) {
        const costsResult = await this.$refs.location_costs.saveCosts(this.newItem.id);

        if (costsResult.error != null) {
          this.showSubmitError("Ошибка сохранения расходов.");
          this.loading = false;
          return;
        }
      }

      if (this.$refs.location_contacts) {
        const contactsResult = await this.$refs.location_contacts.saveContacts(this.newItem.id);

        if (contactsResult.error != null) {
          this.showSubmitError("Ошибка сохранения контактов.");
          this.loading = false;
          return;
        }
      }

      this.loading = false;
      this.$emit('refresh');
      this.onBack();
    },
    getFieldState(field) {
      const value = this.newItem[field];

      if (Array.isArray(value)) {
        return value.length > 0;
      }

      if (typeof value === 'number') {
        return value > 0;
      }

      return !!value;
    },
    onRecruitTasksRefresh() {
      if (this.$refs.location_contacts && this.newItem.id) {
        this.$refs.location_contacts.configure(this.newItem.id);
      }
    },
    async onSelectCustomer(customerId) {
      this.newItem.customer_id = customerId;
      await this.getCustomer(customerId);
    },
    async onSelectOrg(orgId) {
      this.newItem.organization_id = orgId;
      if (this.$refs.organization_select != null) {
        this.newItem.organization_name = this.$refs.organization_select.item.name;
      }
    },
    onSelectUser(userId) {
      this.selectedUserId = userId;
    },
    onSelectProject(userId) {
      this.selectedProjectId = userId;
    },
    async loadUser(userId) {
      const resultUser = await this.getUserById(userId);

      if (resultUser.data == null) return null;

      return resultUser.data;
    },
    async onAddUser(userId) {
      if (userId == null) {
        return;
      }

      if (this.isUserExist(userId)) {
        this.showSubmitError("Сотрудник уже добавлен.")
        return;
      }

      const user = await this.loadUser(userId);

      const locationUser = this.mapUserToLocationUser(user, 0);
      this.users.push(locationUser);

      this.$refs.user_select.onClear();
    },
    onRemoveUser(user) {
        this.setModalDelete(user, this.users, 'Удаление менеджеров');
    },
    async onAddProject(userId) {
      if (userId == null) return;

      if (this.isProjectExist(userId)) {
        const message = "Сотрудник уже добавлен";
        this.showError(message);
        return;
      }

      const user = await this.loadUser(userId);
      const locationUser = this.mapUserToLocationUser(user, 0);

      if (this.projects.length > 0) {
        this.projects.splice(0, 1, locationUser);
      } else {
        this.projects.push(locationUser);
      }

      this.$refs.project_select.onClear();
      this.selectedProjectId = null;
    },
    onRemoveProject(user) {
        this.setModalDelete(user, this.projects, 'Удаление руководителей');
    },
    setModalDelete(item, array, title) {
      const index = array.indexOf(item);
      if (index !== -1) {
        this.deleteRow = item;
      }
      const message = `Вы уверены, что хотите удалить сотрудника ${this.deleteRow.name}?`;
      this.showModalDelete(title, message, function () {
        array.splice(index, 1);
      }.bind(this));
    },
    isUserExist(id) {
      return this.users.find(x => x.id === id) !== undefined;
    },
    isProjectExist(id) {
      return this.projects.find(x => x.id === id) !== undefined;
    },
    mapUserToLocationUser(user, rate) {
      return {
        id: user.id,
        name: user.name,
        role: user.role,
        role_name: user.role_name,
        rate: rate
      }
    },
    canLocationReadFinance() {
      if (this.hasPermission([PERM.LOCATION_READ_FINANCE])) {
        return true;
      }
      return false;
    },
    canLocationEditFinance() {
      if (this.hasPermission([PERM.LOCATION_EDIT_FINANCE])) {
        return true;
      }
      return false;
    },
    readOnlyTapped() {
      this.newItem.read_only = !this.newItem.read_only;
    },
    getReadOnlyVariant() {
      return this.newItem.read_only ? 'danger' : 'success';
    },
    getReadOnlyTitle() {
      return this.newItem.read_only ? 'Редактирование запрещено' : 'Редактирование разрешено';
    },
    getReadOnlyIcon() {
      if (this.newItem.read_only) {
        return "lock";
      } else {
        return "edit";
      }
    },
    prepareReadOnly() {
      if (this.$route.name === 'LocationView') {
        this.isDisabled = true;
        this.readOnlyButtonVisible = false;
        return;
      }

      if (this.hasPermission([PERM.LOCATION_EDIT_OTHER])) {
        this.readOnlyButtonVisible = true;
        this.isDisabled = false;
        return
      }

      if (this.hasPermission([PERM.LOCATION_EDIT])) {
        if (this.newItem.read_only) {
          this.isDisabled = true;
        }
      }
    },
    getRateSymbol() {
      switch (this.newItem.rate_type) {
        case 1: return "%";
        case 2: return "₽";
        default: return "";
      }
    },
    async getCustomer(customerId) {
      if (customerId === 0) return;

      const result = await this.getCustomerById(customerId);

      if (result.data != null) {
        this.customer = result.data;
        this.updateMarketingSource(result.data);
      }
    },
    updateMarketingSource(result) {
      if (this.newItem.marketing_source_id === 0) {
        this.newItem.marketing_source_id = result.data.marketing_source_id;
      }
    }
  }
}
</script>

<style>
.hidden_header {
  display: none;
}

.header-top {
  z-index: 1030 !important;
}

#location-users td {
  vertical-align: middle;
  padding: 10px;
}

#location-projects td {
  vertical-align: middle;
  padding: 10px;
}

/* Chrome, Safari, Edge, Opera */
#input-rate::-webkit-outer-spin-button,
#input-rate::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
#input-rate[type=number] {
  -moz-appearance: textfield;
}

#location-ellipsis-loading {
  white-space: nowrap;
  display: inline-block;
}

@keyframes blink {
  0% { content: "."; }
  33% { content: ".."; }
  66% { content: "..."; }
  100% { content: "."; }
}

#location-ellipsis-loading::after {
  content: ".";
  animation: blink 1.5s infinite step-start;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/Location.vue